module.exports = __webpack_public_path__ + "static/media/comment-exclamation.365ac87d.svg";